import React, { useState, useEffect  } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from 'react-router-dom'
import {
  CardElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import {
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Input,
  Button,
} from 'reactstrap';
import Lottie from 'react-lottie';
import * as pigeon from '../../../lottie/40101-waiting-pigeon.json'
import Alert from 'react-s-alert';
import * as helpers from '../../../utils/Helper'
import * as MyAPI from '../../../utils/MyAPI'

// lottie
let lottieOptions = {
  loop: true,
  autoplay: true,
  animationData: pigeon.default,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

const SubscribeCheckoutForm = (props) => {

  // use history
  let navigate = useNavigate()

  let subscription_status = useSelector(state => {
    if (state.user && state.user.subscription_status) {
      return state.user.subscription_status
    } else {
      return 'unknown'
    }
  });

  let [useSavedPaymentMethod, setUseSavedPaymentMethod] = useState(false)
  let [showPaymentForm, setShowPaymentForm] = useState(true)

  const [billingDetails, setBillingDetails] = useState({
    email: '',
    name: '',
  });
  let [processing, setProcessing] = useState(false)
  let [selectedPlan, setSelectedPlan] = useState("basic")

  const stripe = useStripe();
  const elements = useElements();

  // componentDidMount
  useEffect(() => {

    if (useSavedPaymentMethod === false || subscription_status !== "active") {
      setShowPaymentForm(true)
    } else {
      setShowPaymentForm(false)
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [useSavedPaymentMethod, subscription_status]);


  // createPaymentMethod
  let _createPaymentMethod = async () => {

    if (useSavedPaymentMethod === true && subscription_status === "active") {

      // createSubscription
      _createSubscription({
        paymentMethodId: props.defaultCard._id,
      });

      return;
    }

    try {

      if (!billingDetails.email) {
        throw Error("メールアドレスが入力されていません")
      }
      if (!billingDetails.name) {
        throw Error("お名前が入力されていません")
      }
      if (helpers.validateEmail(billingDetails.email) !== true ){
        throw Error("メールアドレスに誤りがあります。")
      }

      props.setLoading(true)

      let cardElement = elements.getElement(CardElement)

      let result = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
      })
      if (result.error) {

        Alert.error(result.error, {
          position: 'top-right',
          effect: 'slide',
          timeout: 5000
        });

        props.setLoading(false)

        return;
      }

      // createSubscription
      _createSubscription({
        paymentMethodId: result.paymentMethod.id,
      });

    } catch (err) {

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }

    props.setLoading(false)
  }

  // createSubscription
  let _createSubscription = async ({paymentMethodId}) => {

    props.setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.subscribeApi({
        login_token: props.login_token,
        paymentMethodId: paymentMethodId,
        customer_name: billingDetails.name,
        plan_name: selectedPlan,
        use_saved_payment_method: useSavedPaymentMethod,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      let subscription = results_1.subscription
      if (!subscription) {
        throw Error("something must be wrong")
      }
      let _subscription_status = subscription.status
      let pending_setup_intent = subscription.pending_setup_intent

      let setupIntent = results_1.setupIntent

      if (!pending_setup_intent && _subscription_status === "active") {
        // subscribe success

        // notifiy peyment success to parent
        props.paymentSuccess()

        Alert.success("成功", {
          position: 'top-right',
          effect: 'slide',
          timeout: 5000
        });

        props.setLoading(false)

        navigate("/payment_top")

        return;

      } else if (pending_setup_intent) {

        props.setLoading(false)

        _handleActionNeeded(setupIntent, paymentMethodId)

        return;
      }

      props.setLoading(false)
      Alert.info("申し訳ありませんが、弊社までお問い合わせ頂けますでしょうか。", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

      return;

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    props.setLoading(false)
  }

  let _handleActionNeeded = async (setupIntent, paymentMethodId) => {

    // const setupIntent = await stripe.setupIntents.retrieve(
    //   pending_setup_intent,
    // );

    stripe.confirmCardSetup(setupIntent.client_secret, {
        payment_method: paymentMethodId,
      })
      .then((result) => {
        if (result.error) {
          // start code flow to handle updating the payment details
          // Display error message in your UI.
          // The card was declined (i.e. insufficient funds, card has expired, etc)
          console.log("err: ", result.error)
          throw result;
        } else {

          if (result.setupIntent.status === 'succeeded') {
            // // There's a risk of the customer closing the window before callback
            // // execution. To handle this case, set up a webhook endpoint and
            // // listen to setup_intent.succeeded.

            // report payment method confirmed
            _paymentMethodConformed(paymentMethodId)

            return;

          } else {
            // props.setLoading(false)
            Alert.info("申し訳ありませんが、弊社までお問い合わせ頂けますでしょうか。", {
              position: 'top-right',
              effect: 'slide',
              timeout: 5000
            });
          }
        }
      });
  }

  // createSubscription
  let _paymentMethodConformed = async (paymentMethodId) => {

    props.setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.paymentMethodConformed({
        login_token: props.login_token,
        paymentMethodId: paymentMethodId,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      // notifiy peyment success to parent
      props.paymentSuccess()

      Alert.success("成功", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

      props.setLoading(false)

      navigate("/payment_top")

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    props.setLoading(false)
  }

  // select basic plan
  let _selectPlanBasic = () => {
    setSelectedPlan("basic")
  }
  let _selectPlanPremium = () => {
    setSelectedPlan("premium1")
  }

  return (
    <div className="shadow2dp" style={{
      backgroundColor: '#ffffff',
      padding: 12,
    }}>

      <Row style={{
        marginTop: 0,
        marginBottom: 0,
      }}>
        <Col md="6" xs="12">

          {selectedPlan === "basic" && (
            <span>
              選択中
            </span>
          )}

        </Col>
        <Col md="6" xs="12">
          {selectedPlan === "premium1" && (
            <span>
              選択中
            </span>
          )}
        </Col>
      </Row>
      <Row style={{
        marginTop: 0,
        marginBottom: 20,
      }}>

        <Col md="6" xs="12">

          <div onClick={_selectPlanBasic} className={selectedPlan === "basic" ? "shadow2dp" : ""} style={{
            backgroundColor: '#efefef',
            width: '100%',
            textAlign: 'center',
            paddingTop: 30,
            paddingBottom: 30,
            borderColor: '#cccccc',
            borderWidth: 1,
            borderStyle: 'solid',
            cursor: 'pointer',
            fontSize: 24,
          }}>
            ベーシックプラン
          </div>
        </Col>

        <Col onClick={_selectPlanPremium} className={selectedPlan === "basic" ? "" : "shadow2dp"} md="6" xs="12">
          <div style={{
            backgroundColor: '#efefef',
            width: '100%',
            textAlign: 'center',
            paddingTop: 30,
            paddingBottom: 30,
            borderColor: '#cccccc',
            borderWidth: 1,
            borderStyle: 'solid',
            cursor: 'pointer',
            fontSize: 24,
          }}>
            プレミアムプラン
          </div>
        </Col>
      </Row>
      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>

        <Col md="12" xs="12">
          {selectedPlan === "basic" ? (
            <span>
              15秒につき0.24円。最初の60分は無料なので使わなければ無料。いつでもキャンセル出来ます。
            </span>
          ) : (
            <span>
              カスタムモデルを利用できます。API利用料はベーシックと同じ15秒につき0.24円ですが、最低利用料金月額19,800円が発生します。
            </span>
          )}

        </Col>
      </Row>

      {subscription_status === "active" && (
        <Row style={{
          marginTop: 20,
          marginBottom: 20,
        }}>
          <Col onClick={() => setUseSavedPaymentMethod(true)} md="6" xs="12" style={{
            textAlign: 'left',
            cursor: 'pointer',
            color: useSavedPaymentMethod === true ? '#000000' : '#cccccc',
            fontWeight: useSavedPaymentMethod === true ? 'bold' : 'normal',
          }}>
          登録済みの決済情報を利用
          </Col>
          <Col onClick={() => setUseSavedPaymentMethod(false)} md="6" xs="12" style={{
            textAlign: 'right',
            cursor: 'pointer',
            color: useSavedPaymentMethod === false ? '#000000' : '#cccccc',
            fontWeight: useSavedPaymentMethod === true ? 'bold' : 'normal',
          }}>
          新しい決済情報を登録
          </Col>
        </Row>
      )}

      { subscription_status === "active" && useSavedPaymentMethod === true && (
        <div>
          <Row>
            <Col md="3" xs="12">

              {props.defaultCard && props.defaultCard.brand && props.defaultCard.brand.toLowerCase() === "visa" && (
                <img src={require("../../../images/visa_dark.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}
              {props.defaultCard && props.defaultCard.brand && props.defaultCard.brand.toLowerCase() === "american express" && (
                <img src={require("../../../images/americanexpress_dark.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}
              {props.defaultCard && props.defaultCard.brand && props.defaultCard.brand.toLowerCase() === "diners club" && (
                <img src={require("../../../images/dinersclub_dark.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}
              {props.defaultCard && props.defaultCard.brand && props.defaultCard.brand.toLowerCase() === "discover" && (
                <img src={require("../../../images/discover_dark.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}
              {props.defaultCard && props.defaultCard.brand && props.defaultCard.brand.toLowerCase() === "jcb" && (
                <img src={require("../../../images/jcb_dark.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}
              {props.defaultCard && props.defaultCard.brand && props.defaultCard.brand.toLowerCase() === "mastercard" && (
                <img src={require("../../../images/mastercard_dark.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}
              {props.defaultCard && props.defaultCard.brand && props.defaultCard.brand.toLowerCase() === "unionpay" && (
                <img src={require("../../../images/unionpay_dark.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}
              {props.defaultCard && props.defaultCard.brand && props.defaultCard.brand.toLowerCase() === "unknown" && (
                <img src={require("../../../images/unkown_card.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}

            </Col>
            <Col md="9" xs="12">

              {props.defaultCard && props.defaultCard.brand && props.defaultCard.last4 && (
                <span style={{
                  fontSize: 30,
                }}>
                  {props.defaultCard.brand}....{props.defaultCard.last4}
                </span>
              )}

            </Col>
          </Row>

        </div>
      )}

      { showPaymentForm === true && (
        <div>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12">
              <span>名前:</span>
              <br />
              <Input
                disabled={processing}
                type="text"
                style={{
                  width: '100%',
                }}
                name='billingName'
                onChange={(e) => {
                  setBillingDetails({...billingDetails, name: e.target.value});
                }}
                value={billingDetails.name}
                placeholder='' />
            </Col>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12">
              <span>メールアドレス:</span>
              <br />
              <Input
                disabled={processing}
                type="text"
                style={{
                  width: '100%',
                }}
                name='billingEmail'
                onChange={(e) => {
                  setBillingDetails({...billingDetails, email: e.target.value});
                }}
                value={billingDetails.email}
                placeholder='' />
            </Col>
          </Row>

          <Row style={{
            marginTop: 20,
            marginBottom: 30,
          }}>
            <Col md="12" xs="12">
              <span>カード情報:</span>
              <br />
              <div style={{
                padding:8,
                borderWidth: 1,
                borderColor: '#cccccc',
                borderStyle: 'solid',
                borderRadius: 4,
              }}>
                <CardElement options={{
                  disabled: processing,
                  hidePostalCode: true,
                  iconStyle: 'solid',
                  style: {
                    base: {
                      fontWeight: 500,
                      fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                      fontSize: '22px',
                      fontSmoothing: 'antialiased',
                    },
                  },
                }}/>
              </div>
            </Col>
          </Row>

        </div>
      )}

      {/* visual effect for processing... */}
      {processing === true && (
        <div>
          <Row style={{
            marginTop: 20,
            marginBottom: 30,
          }}>
            <Col md="12" xs="12">

              <Lottie style={{
                cursor: 'default',
              }}
                options={lottieOptions}
                isClickToPauseDisabled={true}
                height={200}
                width={200}
                isStopped={false}
                isPaused={false}/>

            </Col>
          </Row>
        </div>
      )}


      <Row style={{
        marginTop: 30,
        marginBottom: 20,
      }}>
        <Col md="12" xs="12">
          {processing === true ? (
            <span>
              処理中です...
            </span>
          ) : (
            <Button
              onClick={_createPaymentMethod}
              color="primary"
              style={{
                cursor: 'pointer',
                width: '100%',
              }}>
                サブスクリプションの登録
              </Button>
          )}

        </Col>
      </Row>

      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="12" xs="12">
          ※ 決済はStripe社のテクノロジーによって安全に行われます。
        </Col>
      </Row>

    </div>
  );
};

export default SubscribeCheckoutForm
